export default __webpack_public_path__ + "static/media/subscription-tick.4dbb6994.svg";